'use client';
import {TageaImage, TageaImageProps} from "@web-libs/ui/ui-components/media/tagea-image";
import {TrmzFile} from "@web-libs/features/files/trmz-file/domain/trmz-file.types";
import {useEffect, useState} from "react";
import {useTrmzFile} from "@web-libs/features/files/trmz-file/application/use-trmz-file.concern";

export type TrmzFileImageProps = Omit<TageaImageProps, "src"> & { file: TrmzFile }

export const TrmzFileImage = (tageaImageProps: TrmzFileImageProps) => {
    return (<>
            {!!tageaImageProps.file.fileUrl && <TageaImage {...tageaImageProps} src={tageaImageProps.file.fileUrl}/>}
        </>
    )
}
